import React from "react";
import { ReadOnlyDeviationChip } from "./helpers";
import { WidgetProps } from "./models";

import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      padding: "7px 0 9px",
    },
  });

interface ReadOnlyDeviationChipWidgetOptions {
  deviationValue: boolean;
  emptyValue?: string;
  hasNominalColor?: boolean;
  hasEmptyColor?: boolean;
}

interface ReadOnlyDeviationChipWidgetProps extends WidgetProps<boolean | null | undefined>, WithStyles<typeof styles> {}

export const ReadOnlyDeviationChipWidgetComponent = (props: ReadOnlyDeviationChipWidgetProps) => {
  const { value, classes } = props;

  const options = props.options as ReadOnlyDeviationChipWidgetOptions | undefined;

  if (!options) {
    throw Error("ui:options must be defined for ReadOnlyDeviationChipWidget.");
  }

  const { deviationValue, emptyValue, hasNominalColor, hasEmptyColor } = options;

  return (
    <ReadOnlyDeviationChip
      value={value}
      deviationValue={deviationValue}
      emptyValue={emptyValue}
      hasNominalColor={hasNominalColor}
      hasEmptyColor={hasEmptyColor}
      className={classes.root}
    />
  );
};

export const ReadOnlyDeviationChipWidget = withStyles(styles)(ReadOnlyDeviationChipWidgetComponent);
